import type { DropdownOption } from '@mesa-labs/mesa-ui/dist/components/Dropdown';

export const OperatorRole = 'ROLE_OPERATOR';
export const PartnerRole = 'ROLE_PARTNER';

export const DefaultRoleFilter = OperatorRole;

// Rendered with allowNoSelection, which supplies the "(No Selection)" item
export const RoleFilterOptions: DropdownOption<string>[] = [
  { label: 'Operators', value: OperatorRole },
  { label: 'Partners', value: PartnerRole },
];

// Operators are identified by email; show the local part (e.g. "jane.doe") to keep compact UI readable.
export const formatOperatorEmail = (email: string): string => email.split('@')[0];

type DeactivatableUser = {
  readonly email: string;
  readonly roles: readonly string[];
};

// Only the operator role is deactivated here; partner accounts are managed from the partner's team page
export const canDeactivateOperator = (user: DeactivatableUser | undefined, currentUserEmail: string | undefined): boolean =>
  !!user
  && user.roles.includes(OperatorRole)
  && user.email.toLowerCase() !== (currentUserEmail ?? '').toLowerCase();

export const getDeactivateOperatorMessage = (user: DeactivatableUser): string => {
  const message = `Are you sure you wish to deactivate the operator "${user.email}"? This will immediately revoke their Ops access.`;

  return user.roles.includes(PartnerRole)
    ? `${message} Their Partner access will remain active.`
    : message;
};
